import NavigateBack from "../components/navigateBack";
import SingleChoice from "../components/singleChoice";
import { useTranslation } from "react-i18next";
import { LanguageOptions } from "../models/LanguageOptions";
import { useHistory, useLocation } from "react-router-dom";

function LangPrefPage({ data }) {
  let history = useHistory();
  const location = useLocation();
  const { i18n } = useTranslation();

  const queryParams = new URLSearchParams(location.search);

  //TODO: Handle on submission logic
  const navigateToOnboarding = (data) => {
    const clinicIdFromQueryParams = queryParams.get("cid");
    i18n.changeLanguage(data.value);
    if (clinicIdFromQueryParams) {
      history.replace({
        pathname: `/onboarding`,
        search: `?cid=${clinicIdFromQueryParams.toString()}`,
      });
    } else {
      history.replace({
        pathname: "/onboarding",
      });
    }
  };

  const getDefaultChoice = () => {
    const defaultLang = new LanguageOptions().options
      .filter((option) => option.code === i18n.language)
      .first();
    return {
      value: defaultLang.code,
      text: defaultLang.name,
    };
  };

  return (
    <div>
      <NavigateBack />
      <SingleChoice
        {...data}
        next="/onboarding"
        onSubmitHandler={navigateToOnboarding}
      />
    </div>
  );
}

export default LangPrefPage;
